import { print } from "graphql";
import { BaseAPI } from "@/api/base.api";
import { Transportadora } from "@/models/transportadora";
import { AxiosObservable } from "axios-observable/dist/axios-observable.interface";
import { map, tap } from "rxjs/operators";

import { API_URL_SERVICE, VUE_APP_SIT_API_URL } from "@/commons/config";
import {
  detectTipoPessoa,
  normalizeDocumentoInput
} from "@/helpers/documento-identificacao.helper";

const transportadora = require("@/query/Transportadora.graphql");

export default class TransportadoraAPI extends BaseAPI<Transportadora> {
  constructor() {
    super();
    this.apiUrl = `${API_URL_SERVICE}`;
  }

  public login(
    cnpj: string,
    token: string,
    recaptcha: string
  ): AxiosObservable<Transportadora> {
    const cnpjTransportadora = normalizeDocumentoInput(cnpj, detectTipoPessoa(cnpj));

    return this.axios.post(`${this.apiUrl}/api/transportadora/signin`, {
      cnpj: cnpjTransportadora,
      token: token,
      recaptcha: recaptcha
    });
  }

  public resetarToken(
    cnpj: string,
    email: string,
    recaptcha: string,
    servico: number
  ): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/api/transportadora/reset-token`, {
      cnpj,
      email,
      recaptcha,
      servico
    });
  }

  public consultaTransportadoraRegularizada(body: any): AxiosObservable<any> {
    return this.axios.post(`${this.apiUrl}/api/transportadoras/consultar-regularizadas`, body)
  }
}

export { TransportadoraAPI }
